var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "options-editor"
  }, [_vm.headerIsVisible ? _c('div', {
    staticClass: "options-editor__header"
  }, [_c('div', {
    staticClass: "options-editor__column"
  }), _c('div', {
    staticClass: "options-editor__column"
  }, [_vm._v("選項文字")]), _c('div', {
    staticClass: "options-editor__column text-center"
  }, [_vm._v("管理")]), _vm.defaultOptionIsVisible ? _c('div', {
    staticClass: "options-editor__column text-center"
  }, [_vm._v("預設值")]) : _vm._e()]) : _vm._e(), _c('VueDraggable', {
    staticClass: "options-editor__body",
    attrs: {
      "handle": ".option-drag-handler",
      "list": _vm.vModelForOptions
    },
    on: {
      "end": _vm.handleDragEnded
    }
  }, _vm._l(_vm.vModelForOptions, function (option, optionIndex) {
    return _c('div', {
      key: "opt-".concat(optionIndex),
      staticClass: "options-editor__row"
    }, [_c('div', {
      staticClass: "options-editor__column"
    }, [_c('i', {
      staticClass: "fa fa-bars option-drag-handler"
    })]), _c('div', {
      staticClass: "options-editor__column options-editor__column--inputs"
    }, [_vm.type === 'date' ? [_c('AppDatePicker', {
      on: {
        "input": function input($event) {
          return _vm.handleDateValueChanged(optionIndex, $event);
        }
      },
      model: {
        value: option.value,
        callback: function callback($$v) {
          _vm.$set(option, "value", $$v);
        },
        expression: "option.value"
      }
    }), _c('b-form-input', {
      staticClass: "options-editor__alias-input",
      attrs: {
        "placeholder": "請填入顯示文字"
      },
      on: {
        "input": _vm.emitOptions
      },
      model: {
        value: option.text,
        callback: function callback($$v) {
          _vm.$set(option, "text", $$v);
        },
        expression: "option.text"
      }
    })] : _c('b-form-input', {
      on: {
        "input": function input($event) {
          return _vm.handleOptionValueChanged(optionIndex, $event);
        }
      },
      model: {
        value: option.text,
        callback: function callback($$v) {
          _vm.$set(option, "text", $$v);
        },
        expression: "option.text"
      }
    })], 2), _c('div', {
      staticClass: "options-editor__column"
    }, [_c('b-button', {
      staticClass: "p-1 d-inline-flex align-items-center",
      attrs: {
        "variant": "inverse-success"
      },
      on: {
        "click": function click($event) {
          return _vm.handleCreateOptionClicked(optionIndex);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-plus"
    }), _vm._v(" 增加 ")]), _c('b-button', {
      staticClass: "ml-2 p-1 d-inline-flex align-items-center",
      attrs: {
        "variant": "inverse-danger",
        "disabled": _vm.hasOnlyOneOption
      },
      on: {
        "click": function click($event) {
          return _vm.handleRemoveOptionClicked(optionIndex);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-remove"
    }), _vm._v(" 移除 ")])], 1), _vm.defaultOptionIsVisible ? _c('div', {
      staticClass: "options-editor__column text-center"
    }, [_c('b-form-radio', {
      attrs: {
        "value": option.value,
        "disabled": _vm.hasOnlyOneOption
      },
      on: {
        "change": function change($event) {
          return _vm.$emit('update:defaultValue', option.value);
        }
      },
      model: {
        value: _vm.defaultValue,
        callback: function callback($$v) {
          _vm.defaultValue = $$v;
        },
        expression: "defaultValue"
      }
    })], 1) : _vm._e()]);
  }), 0)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }